import Lookup from 'src/componentes/select2';
import LucideIcon from 'src/componentes/lucide-icon';

const FarolRevisaoPontoControle = (props) => {
  const handleNome = (item) => {
    return (
      item &&
      item.data && (
        <div className="d-flex align-items-center">
          <LucideIcon
            icon={item.data.icone}
            color={item.data.cor}
            colorHover={item.data.cor}
            size={22}
            className="mr-2"
          />
          <span>{item.data.descricao}</span>
        </div>
      )
    );
  };

  return (
    <Lookup
      labelKey="descricao"
      valueKey="id"
      url="/FarolPontoControleRevisaoLookup"
      clearable={false}
      valueComponent={handleNome}
      {...props}
    />
  );
};

export default FarolRevisaoPontoControle;
